import { API_BASE_URL, authFetchJson } from '../apiClient.ts';
import type { TeamMember } from '../team/teamApi.ts';

export type TenantSummary = {
  id: number;
  name: string;
  createdAt: string;
  // Stripe's, for tenants that came from a checkout. Null for the ones set up by hand.
  subscriptionStatus: string | null;
  stripeCustomerId: string | null;
  demo: boolean;
  users: { active: number; invited: number; revoked: number; admins: number };
  lastSeenAt: string | null;
};

export const fetchTenants = async () =>
  (await authFetchJson(`${API_BASE_URL}/platform/tenants`)).json as TenantSummary[];

export const fetchTenant = async (tenantId: number) =>
  (await authFetchJson(`${API_BASE_URL}/platform/tenants/${tenantId}`)).json as {
    tenant: TenantSummary;
    members: TeamMember[];
  };

export const requestSupportSession = async (tenantId: number) =>
  (
    (
      await authFetchJson(`${API_BASE_URL}/platform/tenants/${tenantId}/support-session`, {
        method: 'POST'
      })
    ).json as { access_token: string }
  ).access_token;

export const stripeCustomerUrl = (customerId: string) =>
  `https://dashboard.stripe.com/customers/${customerId}`;
